import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../../servicios/index.service';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/map';
declare var $;

@Component({
  selector: 'app-seguimiento',
  templateUrl: 'seguimiento.component.html',
})
export class SeguimientoComponent implements OnInit {

  lat:number;
  lng:number;
  user:any;
  userData:any;
  zoom:number = 16;
  usuarios:any;
  usersBuscar:any[] = [];
  msj:boolean = false;
  termino:string;
  datosUser:any;
  mapTypeControl:boolean = true;
  scaleControl: boolean = true;
  usePanning: boolean = true;

  constructor( private _usuarios:UsuariosService, private route: ActivatedRoute ) {
    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini';
    this.data();
  }

  ngOnInit() {
    this._usuarios.seguimiento( this.user ).map(res=>res).subscribe(data=>{
      this.lat = data.lat;
      this.lng = data.lng;
      this.datosUser = data;
      console.log(data);
    });
    $(document).ready(function() {
      let ventana_ancho = $(window).width();
      let ventana_alto = $(window).height();
      $("agm-map").css({"width":ventana_ancho, "height": ventana_alto - 35});
      $("body").css("overflow","hidden");
    });
  }

  data(){
    this.route.params.subscribe(params=>{
      this.user = params["id"];
    });
    this.usuarios = this._usuarios.usuarios;
    this._usuarios.usuarios.subscribe(data=>{
      this.userData = data;
      console.log(this.usuarios);
    });
  }

  buscador( termino:string ){
    console.log("Termino buscador",this.termino);
    this.usersBuscar = this.buscarUser( termino );
    let buscar = this.usersBuscar.length;

    console.log("Buscar", this.usersBuscar.length);
    if(buscar == 1){
      this.msj = false;
    }else{
      this.msj = true;
      this.termino = termino;
    }

  }

  buscarUser( termino:string ){
    let users = [];
    termino=termino.toLowerCase();
    this.termino = termino;

    if( termino ){
      for( let user of this.userData){
        let nombre = user.$key.toLowerCase();
        if( nombre.indexOf( termino ) >= 0 ){
          users.push({$key:nombre, timestamp:user.timestamp, lat:user.lat, lng:user.lng});
        }else{
          this.msj = true;
        }
      }
      return users;
    }else{
      this.msj= false;
      console.log("campo vaciio");
    }


  }
  seguir_user(user:any){
    this.lat = user.lat;
    this.lng = user.lng;
    this.zoom = 15;
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/seguimiento/seguimiento.component.ts